import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { PropertiesService } from 'src/app/properties/service/properties.service';
import { listProperties, removeCaracter } from '../../../core/constants/properties-const';
@Component({
  selector: 'app-address-registry',
  templateUrl: './address-registry.component.html',
  styleUrls: ['./address-registry.component.scss']
})
export class AddressRegistryComponent implements OnInit {

  @Input() public titleModal = 'Complete as informações';
  @Input() public typeModal = 1;
  @Input() public router: string;
  @Input() public cepValue = null;

  @Input()
  public formAddress: FormGroup;

  @Output() public closeModal = new EventEmitter<boolean>();
  @Output() public sendFormRequest = new EventEmitter<string>();

  public fullAddress: string;

  public listProperties = listProperties;
  public openDropDown = false;
  public code = null;
  public subTypeItem = '';
  public enterpriseName = '';
  public neighborhood = '';

  public removeCaracter = removeCaracter;

  constructor(
    private service: PropertiesService,
    private fb: FormBuilder,
    private routers: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.initialForm();
    this.requestForm();
    this.validatorForm();
    this.responseSubType();
    this.enterpriseName = this.formAddress.get('condominium').value;
    this.formAddress.valueChanges.subscribe(x => this.sendFormRequest.emit(x));

  }

  public initialForm(): void {
    if (this.typeModal === 1) {
      this.formAddress = this.fb.group({
        id: [null],
        typeCode: [null],
        zip_code: [null],
        street: [''],
        country: [''],
        number: [''],
        complement: [null],
        neighborhood: [''],
        state: [''],
        city: [''],
        value_zone: [null],
        location_value_zones: [null],
        geographic_area: [null],
        condominium: [''],
        area_util: [null],
        areat_total: [null],
        single_tower: [false],
        number_name_tower: [null],
        floor: [null],
        unity: [null],
        not_number: [false]
      });
    }
  }

  public requestForm(): void {
    // this.service.getZipCode('01534010')
    //   .subscribe(x =>
    //     this.address = `${x.street + ', '}${x.number + ', '}${x.neighborhood + ', '}${x.city + ' - '}${x.state}`);
    this.returnAddress();
    this.code = this.formAddress.get('typeCode').value;
  }

  public returnAddress(): string {
    return this.verificartString(this.formAddress.get('street').value, ', ')
    + this.verificartString(this.formAddress.get('number').value, ', ')
    + this.verificartString(this.formAddress.get('neighborhood').value, ', ')
    + this.verificartString(this.formAddress.get('city').value, '- ')
    + this.verificartString(this.formAddress.get('state').value, '');
  }

  public verificartString(x: string, type: string): string {
    return x ? `${x + type + ''}` : '';
  }

  public validtorModal() {
    if (this.typeModal === 2) {
      this.openDropDown = !this.openDropDown;
    }
    this.closeModal.emit(false);
  }

  public sendForm() {
    this.sendFormRequest.emit(this.formAddress.value);
  }

  public sendRouter() {
    this.routers.navigate(['registro'], { relativeTo: this.route });
  }

  private validatorForm(): void {
    this.service.receivingValidatorForm().subscribe(response => {
      Object.keys(response.controls).forEach((x: string) => {
        this.validField(x, 'floor');
        this.validField(x, 'unity');
        this.validField(x, 'number_name_tower');
      });
    });
  }

  public validField(x: string, field: string): void {
    if (x === field) {
      if (this.formAddress.get(x).value === null) {
        this.formAddress.get(x).setErrors({ required: true });
      }
    }
  }

  public responseSubType() {
    this.listProperties.forEach(x => {
      x.listItems.forEach(data => {
        if (data.code === this.formAddress.get('typeCode').value) {
          this.subTypeItem = data.item;
        }
      });
    });
  }
}